import { mainBus } from "@/common/buses";
import { useAppStore } from "@/common/store/appStore";
import { useCallback, useEffect, useRef, useState } from "react";
import { useBodyLock } from "@/common/hooks/useBodyLock";

export const useGlobalSearch = () => {
  const [searchValue, setSearchValue] = useState<string>("");
  const isSearchBarOpen = useAppStore((state) => state.isSearchBarOpen);
  const toggleSearchBar = useAppStore((state) => state.toggleSearchBar);

  const inputRef = useRef<HTMLInputElement>(null);

  const onSetSearchValue = useCallback((value: string) => {
    setSearchValue(value);
  }, []);

  const onCloseSearch = useCallback(() => {
    inputRef.current?.blur();
    onSetSearchValue("");
    toggleSearchBar();
  }, [inputRef]);

  useEffect(() => {
    mainBus.on("close_search", onCloseSearch);
    return () => mainBus.off("close_search", onCloseSearch);
  }, []);

  useBodyLock(isSearchBarOpen);

  return {
    searchValue,
    isSearchBarOpen,
    inputRef,
    onSetSearchValue,
  };
};
